
import FireBaseHelperOwn from "./modules/firebase";

import { App } from '@capacitor/app';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

import saved from "./modules/saved-and-Followed/saved";
import nav from "./modules/home-screen/nav";
import openUrls from "./modules/open-app-urls/open-urls";

console.log(
  'INDEX JS START',
  performance.now()
);


// ================================
// 🔔 HANDLE NOTIFICATION OPEN
// ================================
function handleNotificationOpen(url) {

  console.log("🔔 Opening notification:", url);

  setTimeout(() => {

    console.log("🔔 Notification opened:", url);

    saved._openNotifications();
    nav._changeNav('Notification');

  }, 500);
}


// ================================
// 🚀 BOOT APP
// ================================
// function bootApp() {


//     localStorage.removeItem('openNotification');

//   if (window.__APP_ALREADY_INITIALIZED__) {
//     console.warn("🚫 App already initialized");
//     return;
//   }

//   window.__APP_ALREADY_INITIALIZED__ = true;

//   console.log("🔥 APP INIT");

//   FireBaseHelperOwn._ALLINIT();
// }

// bootApp();


// START Notifications

function bootApp() {

  // ================================
  // 🧹 Cleanup stale notification flag
  // ================================
  const openNotification =
    localStorage.getItem('openNotification');

  if (openNotification) {

    const savedTimestamp = Number(openNotification);

    // 20 seconds
    const MAX_AGE = 20 * 1000;

    const isExpired =
      Date.now() - savedTimestamp > MAX_AGE;

    if (isExpired) {

      console.log("🧹 Removing stale openNotification");

      localStorage.removeItem('openNotification');
    }
  }

  // 🚫 Prevent double init
  if (window.__APP_ALREADY_INITIALIZED__) {
    console.warn("🚫 App already initialized");
    return;
  }

  window.__APP_ALREADY_INITIALIZED__ = true;

  console.log("🔥 APP INIT");

  FireBaseHelperOwn._ALLINIT();
}

bootApp();


// ================================
// 📱 NATIVE ONLY
// ================================
if (Capacitor.isNativePlatform()) {

  // =========================================
  // 🔗 App opened from deep link / cold start
  // =========================================
  App.addListener('appUrlOpen', (event) => {

    console.log("🚀 appUrlOpen:", event);

    const url = event.url;

    if (!url) return;

    const parsed = new URL(url);

    const isFromNotification =
      parsed.searchParams.get("fromNotification") === "true";

    if (isFromNotification) {
      handleNotificationOpen(url);
    }
  });


  // =========================================
  // 👆 Notification tapped while app alive
  // =========================================
  // PushNotifications.addListener(
  //   'pushNotificationActionPerformed',
  //   (notification) => {

  //     console.log("👆 pushNotificationActionPerformed:", notification);

  //     const data = notification.notification?.data || {};

  //     if (data.url) {
  //       alert("appUrlOpen3: " + data.url);
  //       handleNotificationOpen(data.url);
  //     }
  //   }
  // );

  function openNotificationsPanel() {

    console.log(
      '📬 Opening notifications panel'
    );

    // Example
    saved._openNotifications();

    // or

    document
      .querySelector('.notificationBell')
      ?.click();
  }

  function showNotificationToast(notification) {

    // Remove existing toast
    document
      .querySelectorAll('.maiNotificationToast')
      .forEach(el => el.remove());

    const toast = document.createElement('div');

    toast.className =
      'maiNotificationToast';

    toast.innerHTML = `
    <div class="maiNotificationToastTitle">
      ${notification.title || 'Nueva notificación'}
    </div>

    <div class="maiNotificationToastBody">
      ${notification.body || ''}
    </div>
  `;

    document.body.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.classList.add('show');
    });

    // Tap toast
    toast.onclick = () => {

      toast.remove();

      openNotificationsPanel();
    };

    // Auto hide
    setTimeout(() => {

      toast.classList.remove('show');

      setTimeout(() => {
        toast.remove();
      }, 300);

    }, 5000);
  }

  // =========================================
  // 🔔 Notification received while app open
  // =========================================
  PushNotifications.addListener(
    'pushNotificationReceived',
    (notification) => {

      console.log(
        '🔔 Foreground notification:',
        notification
      );

      showNotificationToast(notification);
    }
  );



  PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (notification) => {

      console.log("👆 pushNotificationActionPerformed:", notification);

      const data = notification.notification?.data || {};

      if (data.url?.includes('fromNotification=true')) {

        // 🧠 Persist notification-open request
        localStorage.setItem(
          'openNotification',
          Date.now().toString()
        );

        console.log("💾 openNotification stored");
      }

      // Optional immediate handling when app already alive
      if (data.url) {
        handleNotificationOpen(data.url);
      }
    }
  );
}
// END notifications



// START Back Button navigation

let lastBackPressTime = 0;
const EXIT_DELAY = 2000; // 2 seconds

async function checkInternet() {
  try {
    // lightweight request (no cache)
    await fetch('https://www.google.com/generate_204', {
      method: 'GET',
      cache: 'no-store',
      mode: 'no-cors'
    });

    return true;
  } catch (e) {
    return false;
  }
}




const backButton = document.querySelector('.backButton');

const backFunctionForAndroid = (canGoBack = null) => {
  // 1. Overlay (highest priority)
  if (handleCustomBack('.topExitButtonOnVideoOverlay')) {
    return;
  }
  // 1. Overlay (highest priority)
  if (handleCustomBack('.topExitCloseVideoButtonOnVideoOverlay')) {
    return;
  }
  // 1. Overlay (highest priority)
  if (handleCustomBack('.topRightExitButtonOnFullScreenOverlay')) {
    return;
  }

  // 2. Fullscreen window
  if (handleCustomBack('.topRightExitButtonOnFullScreenWindow')) {
    return;
  }

  // 3. Stack navigation
  if (handleCustomBack('.CloseCurrentStackPageButton')) {
    return;
  }
  // 4. Fallback to browser navigation
  if (canGoBack) {
    console.log('🔙 Back button pressed on stack Fallback 1');
    window.history.back();
  } else {
    console.log('🔙 Back button pressed on stack Fallback 2');
    const now = Date.now();

    if (now - lastBackPressTime < EXIT_DELAY) {
      console.log('🔙 Back button pressed on stack Fallback 3');
      App.exitApp();
    } else {
      console.log('🔙 Back button pressed on stack Fallback 4');
      lastBackPressTime = now;
      showExitToast();
    }
  }
};

backButton.addEventListener('click', () => {
  console.log('🔙 Back button pressed');
  backFunctionForAndroid()
});

async function updateConnectionStatus(canGoBack) {
  const isOnline = await checkInternet();

  if (!isOnline) {
    App.exitApp();
  } else {

    backFunctionForAndroid(canGoBack)

    return
    // Replaced by the above function

    // 1. Overlay (highest priority)
    if (handleCustomBack('.topExitButtonOnVideoOverlay')) {
      console.log('🔙 Back button pressed on video overlay');
      return;
    }
    // 1. Overlay (highest priority)
    if (handleCustomBack('.topExitCloseVideoButtonOnVideoOverlay')) {
      console.log('🔙 Back button pressed on video overlay close button');
      return;
    }
    // 1. Overlay (highest priority)
    if (handleCustomBack('.topRightExitButtonOnFullScreenOverlay')) {
      console.log('🔙 Back button pressed on full screen overlay');
      return;
    }

    // 2. Fullscreen window
    if (handleCustomBack('.topRightExitButtonOnFullScreenWindow')) {
      console.log('🔙 Back button pressed on full screen window');
      return;
    }

    // 3. Stack navigation
    if (handleCustomBack('.CloseCurrentStackPageButton')) {
      console.log('🔙 Back button pressed on stack navigation');
      return;
    }
    // 4. Fallback to browser navigation
    if (canGoBack) {
      console.log('🔙 Back button pressed on stack Fallback 1');
      window.history.back();
    } else {
      console.log('🔙 Back button pressed on stack Fallback 2');
      const now = Date.now();

      if (now - lastBackPressTime < EXIT_DELAY) {
        console.log('🔙 Back button pressed on stack Fallback 3');
        App.exitApp();
      } else {
        console.log('🔙 Back button pressed on stack Fallback 4');
        lastBackPressTime = now;
        showExitToast();
      }
    }
  }
}

App.addListener('backButton', ({ canGoBack }) => {
  updateConnectionStatus(canGoBack);
});

function showExitToast() {
  let toast = document.getElementById('exit-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'exit-toast';

    toast.innerText = 'Presiona de nuevo para salir';

    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '30px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(0,0,0,0.8)',
      color: '#fff',
      padding: '10px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      zIndex: 999999,
      opacity: '0',
      pointerEvents: 'none', // 👈 IMPORTANT
      transition: 'opacity 0.2s ease'
    });

    document.body.appendChild(toast);
  }

  // show
  toast.style.opacity = '1';
  toast.style.pointerEvents = 'none'; // 👈 always non-interactive

  // clear any previous timeout (important if spam clicking)
  if (toast.hideTimeout) {
    clearTimeout(toast.hideTimeout);
  }

  // hide after delay
  toast.hideTimeout = setTimeout(() => {
    toast.style.opacity = '0';

    // optional: fully hide after fade
    setTimeout(() => {
      toast.style.display = 'none';
    }, 200); // match transition
  }, EXIT_DELAY);

  // ensure it's visible again if reused
  toast.style.display = 'block';
}


function handleCustomBack(selector) {
  const elements = document.querySelectorAll(selector);


  if (selector === '.topExitCloseVideoButtonOnVideoOverlay') {
    const el = elements?.[0];
    if (el) {

      if (isElementOnTop(el)) {
        console.log('Action on back button 7');

        el.click();

        return true;
      }
    }
  }

  // iterate from top-most (last in DOM)
  for (let i = elements.length - 1; i >= 0; i--) {
    const el = elements[i];
    console.log('Action on back button 2');


    console.log({
      visible: isElementVisible(el),
      onTop: isElementOnTop(el),
      element: el
    });


    if (isElementVisible(el) && isElementOnTop(el)) {
      console.log('Action on back button 3');
      el.click();
      return true;
    }
  }


  console.log('Action on back button 4');
  return false;
}


// ✅ Check if element is visible
function isElementVisible(el) {
  const rect = el.getBoundingClientRect();
  const style = window.getComputedStyle(el);

  return (
    rect.width > 0 &&
    rect.height > 0 &&
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0' &&
    el.offsetParent !== null &&
    style.pointerEvents !== 'none'
  );
}


// ✅ Check if element is actually on top (not covered)
function isElementOnTop(el) {
  const rect = el.getBoundingClientRect();

  // Check center point
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 2;

  // If off-screen, ignore
  if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) {
    return false;
  }

  const topElement = document.elementFromPoint(x, y);

  return el === topElement || el.contains(topElement);
}

// END Back Button navigation

// START Deep linking
// App opened via deep link (background / running)
App.addListener('appUrlOpen', (event) => {
  console.log('Deep link (appUrlOpen):', event.url);

  openUrls._parseLocateAndDisplay(event.url);
});

// App opened from CLOSED state
App.getLaunchUrl().then((data) => {
  if (data?.url) {
    console.log('Deep link (cold start):', data.url);

    openUrls._parseLocateAndDisplay(data.url);
  }
});

// END Deep linking












// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register(new URL("/firebase-messaging-sw.js", import.meta.url))
//       .then((registration) => {
//         // console.log(
//         //   "Service Worker registered with scope:",
//         //   registration.scope
//         // );
//       })
//       .catch((error) => {
//         console.error("Service Worker registration failed:", error);
//       });
//   });
// }



// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", async () => {
//     try {
//       const registration = await navigator.serviceWorker.register(
//         new URL("./firebase-messaging-sw.js", import.meta.url)
//       );

//       console.log("SW registered:", registration.scope);
//     } catch (err) {
//       console.error("SW registration failed:", err);
//     }
//   });
// }

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.addEventListener("message", (event) => {
//     if (event.data?.type === "NEW_VERSION_READY") {
//       const confirmUpdate = confirm(event.data.message + "\n\nInstall now?");
//       if (confirmUpdate) {
//         window.location.reload();
//       }
//     }
//   });
// }


// START

// this version is the original
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register(new URL("./firebase-messaging-sw.js", import.meta.url))
//     .then((registration) => {

//       // 🔥 Force check for updates on every load
//       registration.update();

//     });

//   // Prevent infinite reload loop
//   navigator.serviceWorker.addEventListener("controllerchange", () => {
//     if (sessionStorage.getItem("swRefreshed")) return;

//     sessionStorage.setItem("swRefreshed", "true");
//     window.location.reload();
//   });
// }





// const isDev =
//   location.hostname === "localhost" ||
//   location.hostname === "127.0.0.1";

// if (
//   "serviceWorker" in navigator &&
//   !window.serviceWorkerRegistrationStarted
// ) {
//   window.serviceWorkerRegistrationStarted = true;

//   const swUrl = new URL(
//     "./firebase-messaging-sw.js",
//     import.meta.url
//   );

//   navigator.serviceWorker
//     .register(swUrl)
//     .then((registration) => {
//       console.log("SW registered:", registration);
//     })
//     .catch((error) => {
//       console.error("SW registration failed:", error);
//     });

//   // Auto-reload only in production—not localhost.
//   if (!isDev) {
//     let reloadingForNewServiceWorker = false;

//     navigator.serviceWorker.addEventListener(
//       "controllerchange",
//       () => {
//         if (reloadingForNewServiceWorker) return;

//         reloadingForNewServiceWorker = true;
//         window.location.reload();
//       }
//     );
//   }
// }


// const isDev =
//   location.hostname === "localhost" ||
//   location.hostname === "127.0.0.1";

// const wasAlreadyControlled = Boolean(
//   navigator.serviceWorker?.controller
// );

// const swUrl = isDev
//   ? new URL("./firebase-messaging-sw.js", import.meta.url)
//   : "/firebase-messaging-sw.js";

// if (
//   "serviceWorker" in navigator &&
//   !window.serviceWorkerRegistrationStarted
// ) {
//   window.serviceWorkerRegistrationStarted = true;

//   let reloadingForNewServiceWorker = false;

//   navigator.serviceWorker
//     .register(swUrl, {
//       updateViaCache: "none"
//     })
//     .then(async (registration) => {
//       console.log("SW registered:", registration);

//       // Checks for a changed worker whenever the app starts.
//       if (!isDev) {
//         await registration.update();
//       }
//     })
//     .catch((error) => {
//       console.error("SW registration failed:", error);
//     });

//   if (!isDev) {
//     navigator.serviceWorker.addEventListener(
//       "controllerchange",
//       () => {
//         // Do not reload after the first-ever worker install.
//         if (!wasAlreadyControlled) return;

//         // Reload only once when a new version takes control.
//         if (reloadingForNewServiceWorker) return;

//         reloadingForNewServiceWorker = true;
//         window.location.reload();
//       }
//     );
//   }
// }


const isDev =
  location.hostname === "localhost" ||
  location.hostname === "127.0.0.1";

const swUrl = isDev
  ? new URL("./firebase-messaging-sw.js", import.meta.url)
  : "/firebase-messaging-sw.js";

if (
  "serviceWorker" in navigator &&
  !window.serviceWorkerRegistrationStarted
) {
  window.serviceWorkerRegistrationStarted = true;

  navigator.serviceWorker
    .register(swUrl, {
      updateViaCache: "none"
    })
    .then(async (registration) => {
      console.log("SW registered:", registration);

      // Check for an updated Messaging worker.
      await registration.update();
    })
    .catch((error) => {
      console.error("SW registration failed:", error);
    });
}


// if (
//   "serviceWorker" in navigator &&
//   !window.serviceWorkerRegistrationStarted
// ) {
//   window.serviceWorkerRegistrationStarted = true;

//   // Was this page already controlled by a service worker on load?
//   const wasAlreadyControlled = Boolean(
//     navigator.serviceWorker.controller
//   );

//   let reloadingForNewServiceWorker = false;

//   const swUrl = new URL(
//     "./firebase-messaging-sw.js",
//     import.meta.url
//   );

//   navigator.serviceWorker
//     .register(swUrl)
//     .then((registration) => {
//       console.log("SW registered:", registration);
//     })
//     .catch((error) => {
//       console.error("SW registration failed:", error);
//     });

//   navigator.serviceWorker.addEventListener(
//     "controllerchange",
//     () => {
//       // Do not reload after the first-ever SW installation.
//       if (!wasAlreadyControlled) return;

//       // Never reload more than once for the same page load.
//       if (reloadingForNewServiceWorker) return;

//       reloadingForNewServiceWorker = true;
//       window.location.reload();
//     }
//   );
// }

// END



// installApp._initiateInstallApp();

// import openUrls from "./modules/open-app-urls/open-urls";

// import installApp from "./modules/install-app";
// installApp._initiateInstallApp();

// if (window.matchMedia("(display-mode: standalone)").matches) {
//   // User has the PWA installed, redirect them inside the app  
//   // window.location.replace(window.location.href);
//   alert("You have this app installed");
// } else {
//   alert("You do not have this app installed");  
// }





// document.addEventListener("DOMContentLoaded", () => {
//   const body = document.body;

//   // Function to show a click/tap effect
//   const showClickEffect = (x, y) => {
//     const ripple = document.createElement("div");
//     ripple.className = "click-effect";
//     ripple.style.left = `${x}px`;
//     ripple.style.top = `${y}px`;
//     body.appendChild(ripple);

//     // Remove the ripple after animation
//     setTimeout(() => {
//       ripple.remove();
//     }, 600); // Match animation duration
//   };

//   // Function to start tracking a swipe trail
//   const startSwipeTrail = (x, y) => {
//     const trail = document.createElement("div");
//     trail.className = "swipe-trail";
//     trail.style.left = `${x}px`;
//     trail.style.top = `${y}px`;
//     body.appendChild(trail);

//     return trail;
//   };

//   // Event listeners
//   body.addEventListener("pointerdown", (e) => {
//     showClickEffect(e.clientX, e.clientY);
//   });

//   let swipeTrail;
//   body.addEventListener("pointermove", (e) => {
//     if (!swipeTrail) {
//       swipeTrail = startSwipeTrail(e.clientX, e.clientY);
//     } else {
//       swipeTrail.style.left = `${e.clientX}px`;
//       swipeTrail.style.top = `${e.clientY}px`;
//     }
//   });

//   body.addEventListener("pointerup", () => {
//     if (swipeTrail) {
//       swipeTrail.remove();
//       swipeTrail = null;
//     }
//   });
// });

//

//

//

// document.addEventListener("DOMContentLoaded", () => {
//   const body = document.body;
//   let swipeTrail = null;
//   let isSwiping = false;

//   // Function to show a click/tap effect
//   const showClickEffect = (x, y) => {
//     const ripple = document.createElement("div");
//     ripple.className = "click-effect";
//     ripple.style.left = `${x}px`;
//     ripple.style.top = `${y}px`;
//     body.appendChild(ripple);

//     // Remove the ripple after animation
//     setTimeout(() => {
//       ripple.remove();
//     }, 600); // Match animation duration
//   };

//   // Function to start tracking a swipe trail
//   const startSwipeTrail = (x, y) => {
//     const trail = document.createElement("div");
//     trail.className = "swipe-trail";
//     trail.style.left = `${x}px`;
//     trail.style.top = `${y}px`;
//     body.appendChild(trail);

//     return trail;
//   };

//   // Event listener for clicks
//   body.addEventListener("pointerdown", (e) => {
//     // For clicks, trigger the ripple effect
//     showClickEffect(e.clientX, e.clientY);

//     // Start swipe tracking if swipe is initiated
//     isSwiping = true;
//     swipeTrail = startSwipeTrail(e.clientX, e.clientY);
//   });

//   // Event listener for swipe movement
//   body.addEventListener("pointermove", (e) => {
//     if (isSwiping) {
//       // Update the swipe trail's position to follow the mouse/touch
//       swipeTrail.style.left = `${e.clientX}px`;
//       swipeTrail.style.top = `${e.clientY}px`;
//     }
//   });

//   // Event listener to stop swipe tracking
//   body.addEventListener("pointerup", () => {
//     if (isSwiping) {
//       // Remove the swipe trail after the swipe ends
//       swipeTrail.remove();
//       isSwiping = false;
//       swipeTrail = null;
//     }
//   });

//   // Prevent default for touch gestures (optional)
//   body.addEventListener("touchmove", (e) => e.preventDefault(), {
//     passive: false,
//   });
// });

//

//

//

// document.addEventListener("DOMContentLoaded", () => {
//   const body = document.body;
//   let swipeTrail = null;
//   let isSwiping = false;

//   // Function to show a mouse tracking dot
//   const showMouseTrackingDot = (x, y) => {
//     const dot = document.createElement("div");
//     dot.className = "mouse-tracking-dot";
//     dot.style.left = `${x - 5}px`; // Center the dot
//     dot.style.top = `${y - 5}px`; // Center the dot
//     body.appendChild(dot);

//     // Remove the dot after 300ms (fading effect duration)
//     setTimeout(() => {
//       dot.remove();
//     }, 300); // Adjust this to change how long the dot stays
//   };

//   // Function to show a click effect with a bigger fading line
//   const showClickEffect = (x, y) => {
//     const ripple = document.createElement("div");
//     ripple.className = "click-effect";
//     ripple.style.left = `${x - 25}px`; // Center the ripple
//     ripple.style.top = `${y - 25}px`; // Center the ripple
//     body.appendChild(ripple);

//     // Remove the ripple after animation
//     setTimeout(() => {
//       ripple.remove();
//     }, 600); // Match animation duration
//   };

//   // Function to start tracking a swipe trail
//   const startSwipeTrail = (x, y) => {
//     const trail = document.createElement("div");
//     trail.className = "swipe-trail";
//     trail.style.left = `${x}px`;
//     trail.style.top = `${y}px`;
//     body.appendChild(trail);

//     return trail;
//   };

//   // Event listener for mouse or touch movements (for tracking mouse position)
//   body.addEventListener("pointermove", (e) => {
//     // Only track if the user is not clicking (no swipe initiated)
//     if (!isSwiping) {
//       showMouseTrackingDot(e.clientX, e.clientY);
//     }
//     if (isSwiping) {
//       // Update the swipe trail's position to follow the mouse/touch
//       swipeTrail.style.left = `${e.clientX}px`;
//       swipeTrail.style.top = `${e.clientY}px`;
//     }
//   });

//   // Event listener for pointer down (click or swipe start)
//   body.addEventListener("pointerdown", (e) => {
//     // For clicks, trigger the ripple effect
//     showClickEffect(e.clientX, e.clientY);

//     // Start swipe tracking if swipe is initiated
//     isSwiping = true;
//     swipeTrail = startSwipeTrail(e.clientX, e.clientY);
//   });

//   // Event listener for pointer up (end swipe)
//   body.addEventListener("pointerup", () => {
//     if (isSwiping) {
//       // Remove the swipe trail after the swipe ends
//       swipeTrail.remove();
//       isSwiping = false;
//       swipeTrail = null;
//     }
//   });

//   // Prevent default for touch gestures (optional)
//   body.addEventListener("touchmove", (e) => e.preventDefault(), {
//     passive: false,
//   });
// });


// Developer function START
const prod = true;
function addFloatingCopyButtons(cssText, htmlText) {

  if (prod) return
  // if (htmlString.length < 1) return;
  if (localStorage.getItem("hideFloatingFrame") === "true") return;
  const frame = document.createElement("div");
  frame.style.position = "fixed";
  frame.style.top = "20px";
  frame.style.right = "20px";
  frame.style.backgroundColor = "#fff";
  frame.style.border = "1px solid #ccc";
  frame.style.borderRadius = "8px";
  frame.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
  frame.style.padding = "12px";
  frame.style.zIndex = "9999";
  frame.style.cursor = "move";
  frame.style.fontFamily = "sans-serif";
  frame.style.display = "flex";
  frame.style.flexDirection = "column";
  frame.style.alignItems = "flex-start";
  frame.style.gap = "8px";

  frame.addEventListener("mousedown", (e) => {
    isDragging = true;
    offsetX = e.clientX - frame.getBoundingClientRect().left;
    offsetY = e.clientY - frame.getBoundingClientRect().top;
  });

  document.addEventListener("mousemove", (e) => {
    if (isDragging) {
      frame.style.left = e.clientX - offsetX + "px";
      frame.style.top = e.clientY - offsetY + "px";
      frame.style.right = "auto";
    }
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
  });

  // reset the whole thing
  function resetTheHtmlProssesing() {
    console.log("reseting now");
    localStorage.setItem("hideFloatingFrame", "true");
  }

  function createButton(text, color, onClick) {
    const btn = document.createElement("button");
    btn.textContent = text;
    btn.style.padding = "6px 10px";
    btn.style.fontSize = "14px";
    btn.style.border = "none";
    btn.style.borderRadius = "4px";
    btn.style.cursor = "pointer";
    btn.style.backgroundColor = color;
    btn.style.color = "#fff";
    btn.style.fontWeight = "bold";

    btn.addEventListener("click", async () => {
      await onClick();
      const originalText = btn.textContent;
      btn.textContent = "Copied!";
      setTimeout(() => {
        btn.textContent = originalText;
      }, 2000);
    });

    return btn;
  }

  const cssBtn = createButton("Copy CSS", "#0085ff", () =>
    navigator.clipboard.writeText(cssText)
  );
  const htmlBtn = createButton("Copy HTML", "#28a745", () =>
    navigator.clipboard.writeText(htmlText)
  );
  const closeBtn = createButton("Close", "#e63946", () => {
    frame.remove();
    resetTheHtmlProssesing();
  });

  frame.appendChild(cssBtn);
  frame.appendChild(htmlBtn);
  frame.appendChild(closeBtn);

  document.body.appendChild(frame);

  // Make draggable
  let isDragging = false;
  let offsetX = 0;
  let offsetY = 0;

  frame.addEventListener("mousedown", (e) => {
    isDragging = true;
    offsetX = e.clientX - frame.getBoundingClientRect().left;
    offsetY = e.clientY - frame.getBoundingClientRect().top;
    frame.style.transition = "none";
  });

  document.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    e.preventDefault();
    frame.style.left = `${e.clientX - offsetX}px`;
    frame.style.top = `${e.clientY - offsetY}px`;
    frame.style.right = "auto";
    frame.style.bottom = "auto";
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
  });
}


const colorMap = {
  "#ffbc00": "--color-yellow-900",
  "#face53": "--color-yellow-700",
  "#ffe6a1": "--color-yellow-400",
  "#fff8e5": "--color-yellow-100",
  "#f6f6f6": "--color-gray-background",
  "#ff6200": "--color-orange-warning",
};

function processHTML(htmlString) {
  checkAndUpdateHtmlString(htmlString);
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const uniqueClasses = new Map();

  // Convert to camelCase
  function toCamelCase(str) {
    return str
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .trim()
      .split(/\s+/)
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
  }

  // ✅ Updated: Pass global colorMap into here
  function styleToCSS(styleString) {
    return styleString
      .split(";")
      .filter(Boolean)
      .map((rule) => {
        const [property, valueRaw] = rule.split(":").map((s) => s.trim());

        // Normalize and check for color
        const hexMatch = valueRaw.match(/^#([0-9a-f]{6})$/i);
        if (hexMatch) {
          const hexWithHash = `#${hexMatch[1].toLowerCase()}`;
          if (colorMap[hexWithHash]) {
            return `${property}: var(${colorMap[hexWithHash]});`;
          }
        }

        return `${property}: ${valueRaw};`;
      })
      .join(" ");
  }

  function cleanElement(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) return;

    const dataLayer = element.getAttribute("data-layer");
    let className = element.getAttribute("class") || null;

    if (dataLayer) {
      className = toCamelCase(dataLayer);
      element.setAttribute("class", className);
      element.removeAttribute("data-layer");
    }

    const styleAttr = element.getAttribute("style");
    if (styleAttr && className) {
      const css = styleToCSS(styleAttr); // ← uses outer colorMap
      if (!uniqueClasses.has(className)) {
        uniqueClasses.set(className, css);
      }
      element.removeAttribute("style");
    }

    // 🚀 New: remove *all* data-* attributes
    Array.from(element.attributes).forEach((attr) => {
      if (attr.name.startsWith("data-")) {
        element.removeAttribute(attr.name);
      }
    });

    Array.from(element.children).forEach(cleanElement);
  }

  Array.from(doc.body.children).forEach(cleanElement);

  const cleanedHTML = doc.body.innerHTML;
  const cssOutput = Array.from(uniqueClasses.entries())
    .map(([cls, css]) => `.${cls} {\n  ${css}\n}`)
    .join("\n\n");

  // console.log("✅ Cleaned HTML:\n", cleanedHTML);
  // console.log("🎨 Full CSS:\n" + cssOutput);

  // Add floating buttons
  addFloatingCopyButtons(cssOutput, cleanedHTML);
}


// Example usage
const htmlString = `
<div data-layer="NV onboarding con 19" class="NvOnboardingCon19" style="align-self: stretch; flex-direction: column; justify-content: center; align-items: flex-end; gap: 10px; display: inline-flex">
  <div data-layer="NV onboarding con 20" class="NvOnboardingCon20" style="padding: 10px; border-radius: 20px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 10px; display: flex">
    <div data-layer="NV onboarding con 21" class="NvOnboardingCon21" style="padding: 10px; background: #DFDFDF; border-radius: 20px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 10px; display: flex">
      <div data-layer="ci:close-md" class="CiCloseMd" style="width: 20px; height: 20px; position: relative; overflow: hidden">
        <div data-layer="Vector" class="Vector" style="width: 13.33px; height: 13.33px; left: 3.34px; top: 3.33px; position: absolute; outline: 2px white solid; outline-offset: -1px"></div>
      </div>
    </div>
  </div>
</div>
  `;
function checkAndUpdateHtmlString(htmlString) {
  const stored = localStorage.getItem("storedHtmlString");

  if (stored !== htmlString) {
    // console.log("HTML strings are not the same.");
    localStorage.removeItem("hideFloatingFrame");

    localStorage.setItem("storedHtmlString", htmlString);
  } else {
    // console.log("HTML strings are the same.");
  }
}
processHTML(htmlString);
// Developer function END